module.exports = __webpack_public_path__ + "img/bm-2gis.efb00a9b.png";